import { PaletteOptions, Palette } from "@mui/material/styles";
import { createTheme } from "@mui/material";

declare module "@mui/material/styles" {
  interface Palette {
    status: {
      warning: string;
      info: string;
      success: string;
    };
  }
  interface PaletteOptions {
    status?: {
      warning?: string;
      info?: string;
      success?: string;
    };
  }
}

const theme = createTheme({
  palette: {
    background: {
      default: "#FBFAF9", // Warm off-white instead of dark background
      paper: "#FFFFFF", // Clean white for cards
    },
    primary: {
      main: "#5C0629", // Keep the deep plum
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#EAAE5D", // New gold accent matching h1/h4 colors
      contrastText: "#ffffff",
    },
    text: {
      primary: "#2F2F2F", // Slightly darker for better readability
      secondary: "#555555", // Keep existing secondary text
    },
    status: {
      warning: "#D38F00", // Darker amber for WCAG AA compliance
      info: "#0A84C6", // Apple blue 600
      success: "#2E8B57", // Slightly muted green
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#FFFFFF",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: {
          color: "rgb(234, 174, 93)", // Color for h1 elements
        },
        h4: {
          color: "rgb(234, 174, 93)", // Color for h4 elements
          fontFamily: "Playfair Display, serif",
          textAlign: "center",
        },
        h6: {
          color: "#5C0629", // Color for FAQ headings
          fontWeight: "bold",
        },
        body1: {
          color: "#555555", // Color for body text in FAQs
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF", // Clean white paper
          padding: "2px",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)", // Softer shadow
          // borderRadius: "8px", // Rounded corners for a softer look
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px", // Less rounded than before
          textTransform: "none", // No uppercase text
          fontWeight: "600", // Slightly bolder
          "&.MuiButton-containedPrimary": {
            backgroundColor: "#5C0629", // Primary color
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "#732847", // Darker version on hover
            },
          },
          "&.MuiButton-containedSecondary": {
            backgroundColor: "#EAAE5D", // Secondary/gold color
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "rgba(234, 174, 93, 0.9)",
            },
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
          padding: "16px",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "16px",
          height: "24px",
          fontSize: "0.75rem",
          marginRight: "8px",
        },
      },
      defaultProps: {
        size: "small",
      },
    },
    MuiBadge: {
      styleOverrides: {
        badge: {
          fontSize: "0.75rem",
          minWidth: "20px",
          height: "20px",
          borderRadius: "10px",
          padding: "0 6px",
        },
      },
    },
  },
});

export default theme;
